import { Directive } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  selector: '[waTrim]'
})
export class TrimValueDirective {
  constructor(private ngControl: NgControl) {
    if (ngControl.valueAccessor) {
      this.trimValueAccessor(ngControl.valueAccessor);
    }
  }

  trimValueAccessor(valueAccessor: ControlValueAccessor): void {
    const original = valueAccessor.registerOnChange;

    valueAccessor.registerOnChange = (fn: (_: unknown) => void): void => {
      return original.call(valueAccessor, (value: unknown) => {
        return fn(typeof value === 'string' ? value.trim() : value);
      });
    };
  }
}
